import { ChevronLeft } from "lucide-react";
import { Link } from "react-router";
import { OnlineStatusBadge } from "@/components/OnlineStatusBadge";
import { formatRelativeTime } from "@/lib/formatRelativeTime";

export function EntityDetailHeader({
  backTo,
  backLabel,
  name,
  lastSeenAt,
  facts,
}: {
  backTo: string;
  backLabel: string;
  name: string | null;
  lastSeenAt: string | null;
  facts: (string | null)[];
}) {
  const subtitle = [
    ...facts.filter(Boolean),
    lastSeenAt ? `last heartbeat ${formatRelativeTime(lastSeenAt)}` : null,
  ].filter(Boolean);

  return (
    <>
      <Link
        to={backTo}
        className="mb-2 inline-flex items-center gap-1.5 text-sm text-foreground/70 hover:text-accent"
      >
        <ChevronLeft className="h-3 w-3" strokeWidth={3.5} aria-hidden="true" />
        {backLabel}
      </Link>

      {name === null ? (
        <div className="mb-4 animate-pulse">
          <div className="h-7 w-52 rounded bg-surface" />
          <div className="mt-1.5 h-3.5 w-64 rounded bg-surface" />
        </div>
      ) : (
        <div className="mb-4">
          <h1 className="flex flex-wrap items-center gap-2.5 text-2xl font-semibold tracking-tight">
            {name}
            <OnlineStatusBadge lastSeenAt={lastSeenAt} />
          </h1>
          {subtitle.length > 0 && (
            <p className="mt-0.5 text-sm text-foreground/70">
              {subtitle.join(" · ")}
            </p>
          )}
        </div>
      )}
    </>
  );
}
